import { connect } from 'react-redux';
import SelectPaymentMethod from './select_payment_method';
import { setMethod, placeOrder } from '../../actions/checkout_process';

const mapStateToProps = ({ checkoutProcess }) => checkoutProcess;

export default connect(mapStateToProps, {
  setMethod, placeOrder
})(SelectPaymentMethod);
